import React, {  } from 'react';
import {
  Box,
  IconButton,
  Typography
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, ToolbarStyled } from '../StyledComponents';
import BuscaContatos from '../../Busca/buscaContatos';
import LanguageSelector from '../../LanguageSelector';
import ProfilePhoto from '../../ProfilePhoto';
import { SearchContainer } from '../StyledComponents';
import Logo from '../../../assets/STATO-INTOO-LOGO-MY-INTOO-VERS-2 A.png';

interface HeaderProps {
  open: boolean;
  isMobile: boolean;
  handleMobileMenuToggle: () => void;
  paginaAtual: string;
  handleMenuClick: (url: string) => void;
}

/**
 * Componente do cabeçalho principal do app
 */
const Header: React.FC<HeaderProps> = ({
  open,
  isMobile,
  handleMobileMenuToggle,
  paginaAtual,
  handleMenuClick
}) => {
  return (
    <AppBar position="fixed" open={open} isMobile={isMobile}>
      <ToolbarStyled>
        {/* Botão de menu hamburger (apenas mobile) */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isMobile && (
            <IconButton
              color="primary"
              aria-label="abrir menu"
              onClick={handleMobileMenuToggle}
              edge="start"
              sx={{ mr: 2 }}
              data-testid="mobile-menu-button"
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Logo e título */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={Logo}
              alt="logo"
              style={{
                height: '40px',
                marginRight: '12px',
                display: 'block',
                cursor: 'pointer'
              }}
              onClick={() => handleMenuClick('/')}
              title="Ir para o Dashboard"
            />
            <Typography
              variant="h6"
              sx={{
                color: '#1976d2',
                fontWeight: 'bold',
                display: { xs: 'none', sm: 'block' }
              }}
              noWrap
            >
              {paginaAtual}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              borderRadius: '16px',
              backgroundColor: '#f8f9fa',
              padding: '2px',
              mr: 2
            }}
          >
            <SearchContainer>
              <BuscaContatos />
            </SearchContainer>
          </Box>

          {/* Seletor de idioma */}
          <Box sx={{ display: 'block' }}>
            <LanguageSelector />
          </Box>

          {/* Componente de foto de perfil */}
          <ProfilePhoto />
        </Box>
      </ToolbarStyled>
    </AppBar>
  );
};

export default Header;
